import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { cx } from '../utils/cx'
import type { PaymentMethodSelectorProps } from './types'
import './PaymentMethodSelector.css'

/** Selector de método de pago (bundle B3): lista de radio de 56 px con logo a la derecha; seleccionado en primary-soft. */
export function PaymentMethodSelector({ methods, value, onChange, label, name, className }: PaymentMethodSelectorProps) {
  const { t } = useTranslation()
  const uid = useId()
  const groupName = name ?? `hp-pay-${uid}`
  const labelId = `${groupName}-label`
  return (
    <fieldset className={cx('hp-paymethod', className)} aria-labelledby={labelId}>
      <legend id={labelId} className="hp-paymethod__legend">
        {label ?? t('v2.ds.paymentMethod.pregunta')}
      </legend>
      <div className="hp-paymethod__list">
        {methods.map((m) => {
          const checked = m.id === value
          const text = m.label ?? t(m.kind === 'saved_card' ? 'v2.ds.paymentMethod.tarjetaGuardada' : 'v2.ds.paymentMethod.otraTarjeta')
          return (
            <label key={m.id} className={cx('hp-paymethod__option', checked && 'hp-paymethod__option--checked')}>
              <input type="radio" name={groupName} value={m.id} checked={checked} onChange={() => onChange(m.id)} className="hp-paymethod__input" />
              <span className="hp-paymethod__radio" aria-hidden="true" />
              <span className="hp-paymethod__text">
                {text}
                {m.detail && <span className="hp-paymethod__detail tnum"> {m.detail}</span>}
              </span>
              {m.brand && (
                <span className="hp-paymethod__brand" aria-hidden="true">
                  {m.brand}
                </span>
              )}
            </label>
          )
        })}
      </div>
      {methods.length === 1 && <p className="hp-paymethod__only">{t('v2.ds.paymentMethod.soloTarjeta')}</p>}
    </fieldset>
  )
}
